// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2eaIL","caret":"Select_caret__1rdVd"};